import { Box, FormField, Input } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { ButtonData_Type, Link_Target } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { LinkSettings } from "./../../ui-components";
import { BUTTON_TEXT_INPUT } from "../dataHooks";
const SettingsComponent = ({
  buttonData,
  onChange,
  inputRef,
  setIsValidUrl
}) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP3" }, /* @__PURE__ */ React.createElement(FormField, { label: t("ButtonModal_Button_Text") }, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      onChange: (e) => onChange({ ...buttonData, text: e.target.value }),
      value: buttonData.text,
      dataHook: BUTTON_TEXT_INPUT,
      placeholder: t("ButtonModal_InputName_Placeholder")
    }
  )), buttonData.type === ButtonData_Type.LINK && /* @__PURE__ */ React.createElement(
    LinkSettings,
    {
      linkValue: {
        url: buttonData.link?.url,
        openInNewTab: buttonData.link?.target === "BLANK",
        nofollow: buttonData.link?.rel?.nofollow,
        sponsored: buttonData.link?.rel?.sponsored
      },
      onChange: (value, status) => {
        setIsValidUrl?.(true);
        const link = value.url ? {
          ...buttonData.link,
          url: value.url,
          target: value.openInNewTab ? Link_Target.BLANK : Link_Target.TOP,
          rel: {
            nofollow: Boolean(value.nofollow),
            sponsored: Boolean(value.sponsored)
          },
          anchor: void 0
        } : void 0;
        if (status === "ERROR") {
          setIsValidUrl?.(false);
          return;
        }
        onChange({ ...buttonData, link });
      },
      options: {
        showNewTabCheckbox: true,
        showNoFollowCheckbox: true,
        showSponsoredCheckbox: true
      },
      inputRef
    }
  ));
};
export {
  SettingsComponent
};
//# sourceMappingURL=settings-component.js.map
